import React from 'react';
import {Icon, PriorityIcon, TextColor} from '@priority-software/priority-style-react';
import {ModernTooltip, TooltipPosition} from './Tooltip/ModernTooltip';

type IconWithTooltipProps = {
    componentClasses?: string;
    icon: PriorityIcon;
    iconColor?: TextColor;
    tooltip?: string;
    onClick?: () => void;
    disabled?: boolean;
    dataTestId?: string;
    position?: TooltipPosition;
};

export const IconWithTooltip = (props: IconWithTooltipProps) => {
    const {disabled, tooltip, position = 'top-start', iconColor = 'primary-700'} = props;

    const iconElement = <Icon {...props} iconColor={iconColor} />;

    if (disabled || !tooltip) {
        return iconElement;
    }

    return (
        <ModernTooltip tooltip={tooltip} position={position}>
            {iconElement}
        </ModernTooltip>
    );
};
